<ncp-table #physicalFindings [(options)]="options"></ncp-table>
